<template>
  <div class="tq-person-selector-tabs">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="按部门" name="department"></el-tab-pane>
      <!-- <el-tab-pane label="按职务" name="position"></el-tab-pane> -->
    </el-tabs>
  </div>
</template>

<script lang="ts" setup>
import { ref } from "vue";
const activeName = ref<"department" | "position">("department");

const handleClick = (tab: any) => {
  console.log("🚀 ~ 当前打印的内容 ~ tab:", tab);
};
</script>
